import { useAccount } from "@helium/account-fetch-cache-hooks";
import { useIdl } from "./useIdl";
import { useIdlAccount } from "./useIdlAccount";
import { useEffect } from "react";
export function useAnchorAccount(key, type, 
// Perf optimization - set if the account will never change, to lower websocket usage.
isStatic = false) {
    const { account: rawAccount } = useAccount(key);
    const { info: idl, error, loading } = useIdl(rawAccount?.owner);
    useEffect(() => {
        if (!loading && rawAccount && !idl) {
            console.warn(`Idl not found for ${rawAccount.owner.toBase58()}`);
        }
    }, [idl, loading, rawAccount]);
    return {
        ...useIdlAccount(key, idl, type, isStatic),
        error,
    };
}
//# sourceMappingURL=useAnchorAccount.js.map